import { Component } from "@angular/core";
import { MzBaseModal, MzToastService } from "ng2-materialize";
import { Feedback } from "../../interfaces/feedback";
import { FeedbackService } from "../../services/feedback/feedback.service";

@Component({
  selector: "app-feedback-modal",
  templateUrl: "./feedback-modal.component.html",
  styleUrls: ["./feedback-modal.component.scss"],
})
export class FeedbackModalComponent extends MzBaseModal {
  feedback: Feedback = {
    message: "",
    contact: false,
  };

  constructor(
    private feedbackService: FeedbackService,
    private toastService: MzToastService
  ) {
    super();
  }

  sendFeedback() {
    this.feedbackService
      .saveFeedback(this.feedback)
      .then(() => {
        this.modalComponent.close();
        this.toastService.show(
          "Vielen Dank für Dein Feedback!",
          4000,
          "notification-toast"
        );
      })
      .catch(() => {
        this.modalComponent.close();
        this.toastService.show(
          "Feedback konnte nicht übermittelt werden.",
          4000,
          "notification-toast"
        );
      });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/feedback-modal/feedback-modal.component.ts